// extracted by mini-css-extract-plugin
module.exports = {"load-more":"_1p0Dm"};